function ErrorFallback(): React.ReactElement {
  return <div>Ocorreu algum erro</div>
}

export default ErrorFallback
